<template>
	<b-card v-if="ticket">
        <b-row align-h="between">
            <b-col sm="6" style="text-align: left;">
                <div @click="routeToDashboard(selectedSiteId, year)" style="font-weight: bold; font-size: 1.2em; align-self: center; cursor: pointer">{{selectedSite.name}}</div>
                <br>
                <br>
                <b-row class="my-1">
                    <b-col sm="5" style="text-align: left; font-weight: bold; align-self: center">
                        <label>{{ $t('predictedDate') }}:</label>
                    </b-col>
                    <b-col sm="7" style="text-align: left">
                        <el-date-picker
                            v-model="ticket.expectedDate"
                            type="date"
                            :readonly="true"
                            format="dd/MM/yyyy"
                            style="width: 100%;"
                        />
                    </b-col>
                </b-row>
                <b-row class="my-1">
                    <b-col sm="5" style="text-align: left; font-weight: bold; align-self: center">
                        <label>{{$t('itemType')}}:</label>
                    </b-col>
                    <b-col sm="7" style="text-align: left">
                        {{$t(ticketTypeOptions(ticket.ticketType))}}
                    </b-col>
                </b-row>
                <b-row class="my-1">
                    <b-col sm="5" style="text-align: left; font-weight: bold; align-self: center">
                        <label>{{$t('status')}}:</label>
                    </b-col>
                    <b-col sm="7" style="text-align: left">
                        {{retrieveTicketStatus(ticket.state)}}
                    </b-col>
                </b-row>
            </b-col>
            <b-col sm="5" style="text-align: right; top: 53px;">
                <b-row v-for="(member, index) in ticket.originalMembers" :key="index" class="my-1">
                    <b-col sm="5" style="text-align: left; font-weight: bold; align-self: center; text-indent: 20px;">
                        <label>{{ $t(member.type) }}:</label>
                    </b-col>
                    <b-col sm="7" style="text-align: left; text-indent: -10px;">
                        <label>{{ `${member.firstName} ${member.lastName}` }}</label>
                    </b-col>
                </b-row>
            </b-col>
            <b-col v-if="isAdmin" style="text-align: right">
                <b-btn v-if="ticket.isErasable" variant="danger" @click="deleteItem"><i class="fas fa-trash-alt"></i></b-btn>
            </b-col>
        </b-row>
        <b-row v-if="ticket && ticket.ticketType && (ticket.ticketType == 'Audit' || ticket.ticketType == null)" align-h="start" style="margin-top: 30px">
            <TicketDetailCard :ticket="ticket" :selectedSiteId="selectedSiteId" :isPostsEmpty="ticket.posts.length == 0" :ticketId="ticketId" :updateFunction="retrieveTicket" pageType="detail"></TicketDetailCard>
        </b-row>
        <b-row v-if="ticket && ticket.ticketType && ticket.ticketType == 'Action'" align-h="start" style="margin-top: 30px">
            <b-card style="width: 100%">
                <b-row class="my-1">
                    <b-col sm="3" style="text-align: left; font-weight: bold;">
                        <label>{{ $t('nonconformity') }}:</label>
                    </b-col>
                    <b-col sm="9" style="text-align: left;">
                        {{ ticket.textInput ? ticket.textInput : "-"  }}
                    </b-col>
                </b-row>
                <b-row class="my-1">
                    <b-col cols="3" style="text-align: left; font-weight: bold;">
                        <label>{{ $t('actionTitle') }}:</label>
                    </b-col>
                    <b-col sm="9" style="text-align: left;white-space: pre-line;">{{ticket.scope?$t(ticket.scope):"-"}}</b-col>
                </b-row>
                <b-row class="my-1">
                    <b-col sm="3" style="text-align: left; font-weight: bold;">
                        <label>{{ $t('note') }}:</label>
                    </b-col>
                    <b-col sm="9" style="text-align: left;">
                        {{ ticket.note ? ticket.note : "-" }}
                    </b-col>
                </b-row>
                <b-row class="my-1">
                    <b-col sm="3" style="text-align: left; font-weight: bold; align-self: center">
                        <label>{{ $t('auditDate') }}:</label>
                    </b-col>
                    <b-col sm="9" style="text-align: left">
                        <el-date-picker
                            v-model="ticket.auditDate"
                            type="date"
                            :readonly="true"
                            format="dd/MM/yyyy"
                            style="width: 100%;"
                          />
                    </b-col>
                </b-row>
                <b-row align-h="start" style="margin-top: 30px">
                    <b-col>
                        <b-button v-if="$store.state.user.permissions.canStartAudits" v-show="isAdmin && !ticket.state && ticket.posts.length == 0" @click="showUpdateTicketModal($event.target)" style="float: left">{{ $t('edit') }}</b-button>
                        <b-button v-show="isAgent && ticket.posts.length == 0" @click="showReplyModal($event.target)" style="float: right">{{ $t('reply') }}</b-button>
                    </b-col>
                </b-row>
            </b-card>
        </b-row>
        <b-col>
            <b-card v-for="(post,index) in ticket.posts" :key="index" :style="{'margin-top': '15px', cursor: 'pointer', 'background-color': index%2 === 0 ? '#f7ebca' : ''}">
                <b-row no-gutters v-if="!isAdmin && index%2===0 && index === ticket.posts.length-1 && !ticket.state">
                    <b-col style="text-align: right">
                        <b-btn variant="danger" @click="deletePost($event, post.id)"><i class="fas fa-trash-alt"></i></b-btn>
                    </b-col>
                </b-row>
                <b-row no-gutters v-else-if="isAdmin && index%2 ===1 && index === ticket.posts.length-1 && !ticket.state">
                    <b-col style="text-align: right">
                        <b-btn variant="danger" @click="deletePost($event, post.id)"><i class="fas fa-trash-alt"></i></b-btn>
                    </b-col>
                </b-row>
                <b-row v-if="isAgent" no-gutters class="mt-4">
                    <span style="font-weight: bold">{{ $t('response') }}:</span>
                    <b-col style="text-align: left">
                        {{ post.answerText }}
                    </b-col>
                </b-row>
                <b-row v-if="post.documents.length" align-h="start" class="mt-4" no-gutters>
                    <span style="font-weight: bold">{{ $t('Documents') }}:</span>
                    <b-col cols="1" v-for="(file, index) in post.documents" :key="index" style="align-self: center; cursor: pointer">
                        <div @click="downloadFile(file.fileUrl)" style="text-align: center"><i class="fas fa-file-alt fa-lg"></i></div>
                        <div style="font-size: 12px; text-align: center">{{file.filename | textToShortText}}</div>
                    </b-col>
                </b-row>
                <b-row v-if="index%2===0 && index === ticket.posts.length-1 && !ticket.state" align-h="end" no-gutters class="mt-4">
                    <b-col v-if="isAdmin" @click="showReplyModal($event.target, 'negative')" cols="2" lg="1" style="cursor: pointer">
                        <b-row no-gutters align-h="end">
                            <b-col>
                                <i class="fas fa-times-circle fa-lg"></i>
                                <div>{{$t('negativeControl')}}</div>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col v-if="isAdmin" cols="1" lg="1" style="cursor: pointer" @click="closePost($event)">
                        <b-row no-gutters>
                            <b-col>
                                <i class="fas fa-check fa-lg"></i>
                                <div>{{ $t('close') }}</div>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col v-if="isAgent && post.userId === $store.state.user.id" cols="1" lg="1" style="cursor: pointer">
                        <b-button @click="$store.state.user.permissions.canStartAudits&&post.extendedDate!==null? showUpdatePostModal($event.target, post, 'negative'): showUpdatePostModal($event.target, post)">{{ $t('edit') }}</b-button>
                    </b-col>
                </b-row>
                <b-row v-else-if="index === ticket.posts.length-1 && !ticket.state" align-h="end" no-gutters class="mt-4">
                    <b-col cols="1">
                        <b-button v-if="isAgent" @click="showReplyModal($event.target)">{{ $t('reply') }}</b-button>
                    </b-col>
                    <b-col v-if="isAgent && post.userId === $store.state.user.id " cols="1">
                        <b-button @click="$store.state.user.permissions.canStartAudits&&post.extendedDate!==null? showUpdatePostModal($event.target, post, 'negative'): showUpdatePostModal($event.target, post)">{{ $t('edit') }}</b-button>
                    </b-col>
                    <b-col v-else-if="isAdmin && post.userId === $store.state.user.id " cols="1">
                        <b-button @click="$store.state.user.permissions.canStartAudits&&post.extendedDate!==null? showUpdatePostModal($event.target, post, 'negative'): showUpdatePostModal($event.target, post)">{{ $t('edit') }}</b-button>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
        
    </b-card>
    <div v-else></div>
</template>

<script>
import Upload from '../../../components/Upload';
import UploadRegular from '../../../components/UploadRegular';
import TicketDetailCard from '../../../components/TicketDetailCard';
import uuid from 'uuid/v4';
import _ from 'lodash';
import moment from 'moment';

export default {
    name: 'DofDetail',
    components: {UploadRegular, Upload, TicketDetailCard},
    data() {
        return {
            ticket: null,
            isIndexedActions: false,
            actions: [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false
            ],
            ticketId: null,
            ticketType: null,
            selectedSiteId: null,
            isErasable: null,
            extendedDate: new Date()
        };
    },
    methods: {
        firstExtendedDate(ticket) {
            let extendedDates = _.map(ticket.posts, 'extendedDate');
            // returns valid date : if there isn't any extended date, returns expected date.
            let selectedDate = extendedDates[Object.keys(extendedDates).length - 1]
                ? moment(extendedDates[Object.keys(extendedDates).length - 1]).format('YYYY-MM-DD')
                : '-';
            return selectedDate;
        },
        deletePost(event, postId) {
            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, () => {
                this.axios
                    .delete(`/audits/post/${postId}/`)
                    .then(() => {
                        this.ticket.posts = this.ticket.posts.filter(post => {
                            return post.id !== postId;
                        });
                        if (this.ticket.posts.length) {
                            this.ticket.posts[this.ticket.posts.length - 1].isErasable = true;
                        } else {
                            this.ticket.isErasable = true;
                        }
                    })
                    .catch(() => {
                        this.showErrorNotification(
                            'Silme işlemi gerçekleştirilemedi, tekrar deneyin.'
                        );
                    });
            });
        },
        deleteItem(event) {
            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, () => {
                this.axios
                    .delete(`/audits/${this.route.params.ticket_id}`)
                    .then(() => {
                        this.$router.push({
                            name: 'ticket-list',
                            params: {site_id: this.route.params.site_id},
                            query: {start_date: this.year}
                        });
                    })
                    .catch(() => {
                        this.showErrorNotification(
                            'Silme işlemi gerçekleştirilemedi, tekrar deneyin.'
                        );
                    });
            });
        },
        closePost(event) {
            let text = 'Madde kapatılacaktır, emin misiniz?';
            this.showWarnModal(event.target, text);
            this.$eventHub.$once(this.$store.state.modal.eventId, () => {
                this.axios.put(`/${this.selectedSiteId}/audits/${this.ticketId}/close`).then(() => {
                    this.ticket.state = 1;
                });
            });
        },
        showUpdateTicketModal(target) {
            if (_.get(this.ticket, 'ticketType') == 'Action') {
                if (this.isIndexedActions) {
                    this.ticket.actionCheckList = this.actions;
                }
                this.$store.commit('SET_MODAL', {
                    eventId: uuid(),
                    type: 'updateTicket',
                    payload: {
                        siteId: this.selectedSiteId,
                        ticket: this.ticket,
                        ticketId: this.ticketId,
                        ticketType: this.ticketType
                    }
                });
                this.$nextTick(() => {
                    this.$root.$emit('bv::show::modal', 'createAction', target);
                    this.$eventHub.$once(this.$store.state.modal.eventId, updatedTicket => {
                        for (let key in updatedTicket) {
                            this.ticket[key] = updatedTicket[key];
                        }
                        this.retrieveTicket();
                    });
                });
            } else {
                this.$store.commit('SET_MODAL', {
                    eventId: uuid(),
                    type: 'updateTicket',
                    payload: {
                        siteId: this.selectedSiteId,
                        ticket: this.ticket,
                        ticketId: this.ticketId,
                        ticketType: this.ticketType
                    }
                });
                this.$nextTick(() => {
                    this.$root.$emit('bv::show::modal', 'createTicket', target);
                    this.$eventHub.$once(this.$store.state.modal.eventId, updatedTicket => {
                        for (let key in updatedTicket) {
                            this.ticket[key] = updatedTicket[key];
                        }
                        this.retrieveTicket();
                    });
                });
            }
        },
        showUpdatePostModal(target, post, replyType = null) {
            this.$store.commit('SET_MODAL', {
                eventId: uuid(),
                type: 'updatePost',
                payload: {
                    siteId: this.selectedSiteId,
                    ticket: this.ticket,
                    post: post,
                    ticketId: this.ticketId,
                    replyType: replyType
                }
            });
            this.$nextTick(() => {
                this.$root.$emit('bv::show::modal', 'createPost', target);
                this.$eventHub.$once(this.$store.state.modal.eventId, createdPost => {
                    for (let key in post) {
                        post[key] = createdPost[key];
                    }
                });
            });
        },
        handleRemoving(event, fileId) {
            this.ticket.documents = this.ticket.documents.filter(document => {
                return document.id !== fileId;
            });
        },
        retrieveTicket() {
            return this.axios
                .get(`/${this.selectedSiteId}/audits/${this.ticketId}`)
                .then(({data}) => {
                    this.ticket = data;
                    let actions = '';
                    try {
                        _.each(JSON.parse(this.ticket.scope), (actionCheck, actionIndex) => {
                            if (actionCheck) {
                                actions +=
                                    '→ ' +
                                    this.$t(this.$store.state.nonconformances[actionIndex - 1].action) +
                                    '\n';
                            }
                        });
                        this.isIndexedActions = true;
                        this.actions = this.ticket.scope;
                        this.ticket.scope = actions;
                    } catch (error) {
                        console.error(error);
                    }
                    this.ticketType = _.get(data, 'ticketType');
                });
        },
        retrieveTicketStatus(state) {
            let status = state == 0 ? this.$t('openTicket') : this.$t('closedTicket');
            return status;
        },
        showReplyModal(target, replyType) {
            this.$store.commit('SET_MODAL', {
                eventId: uuid(),
                type: 'createPost',
                payload: {
                    siteId: this.selectedSiteId,
                    ticket: this.ticket,
                    ticketId: this.ticketId,
                    replyType: replyType
                }
            });
            this.$nextTick(() => {
                this.$root.$emit('bv::show::modal', 'createPost', target);
                this.$eventHub.$once(this.$store.state.modal.eventId, createdPost => {
                    this.ticket.posts.push(createdPost);
                    this.ticket.isErasable = false;
                });
            });
        },
        ticketTypeOptions(type) {
            let returnType = null;
            if(this.gbId(this.$store.state.user.customerId)){
                type === 'Audit' ? returnType = 'AuditGaranti': returnType = 'ActionGaranti';
                return returnType;
            };
            if(!this.gbId(this.$store.state.user.customerId)){
                return type;
            };
        }
    },
    computed: {
        selectedSite() {
            return _.find(this.sites, {id: this.selectedSiteId});
        },
        nonconformanceArticleText() {
            if (_.get(this.ticket, 'ticketType') == 'Audit') {
                return _.find(this.$store.state.nonconformances, {id: this.ticket.nonconformanceId})
                    .article;
            }
        },
        nonconformanceActionText() {
            if (_.get(this.ticket, 'ticketType') == 'Audit') {
                if (this.ticket.nonconformanceId !== 13) {
                    return _.find(this.$store.state.nonconformances, {
                        id: this.ticket.nonconformanceId
                    }).action;
                } else {
                    return this.ticket.customNonconformance;
                }
            }
        },
        isAdmin() {
            return this.$store.state.user.permissions.canStartAudits;
        },
        isAgent() {
            return this.$store.state.user.permissions.canReplyToAudits;
        }
    },
    created() {
        this.ticketId = this.route.params.ticket_id
            ? Number(this.route.params.ticket_id)
            : this.ticketId;
        this.selectedSiteId = this.route.params.site_id
            ? Number(this.route.params.site_id)
            : this.selectedSiteId;
        this.retrieveTicket();
    }
};
</script>

<style scoped>
</style>

<i18n src="../../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "actionTitle": "Alınacak Aksiyon",
            "files": "Dosyalar",
            "negativeControl": "Olumsuz Kontrol",
            "itemType": "Madde türü",
            "openTicket": "Açık",
            "closedTicket": "Kapalı",
            "Audit":"Düzeltici Faaliyet",
            "AuditGaranti": "Uygunsuzluk Maddesi",
            "Action":"Önleyici Faaliyet",
            "ActionGaranti":"Aksiyon Planı"
        },
        "en": {
            "actionTitle": "Action",
            "files": "Files",
            "negativeControl": "Negative Control",
            "itemType": "Type",
            "openTicket": "Open",
            "closedTicket": "Closed",
            "Audit":"Corrective Action",
            "Action":"Preventive Action",
            "AuditGaranti": "Corrective Action",
            "ActionGaranti":"Action plan"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Audit/Audits/TicketDetail.vue